import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
//import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import momentJalaali from 'moment-jalaali';
import { Calendar } from 'react-datepicker2';

function DatePickerDialog(props) {
  const { open, onClose } = props;
  const [date, setDate] = useState(momentJalaali());
  const [time, setTime] = useState('morningtillafternoon');
  const range = [
    {
      disabled: true,
      start: momentJalaali().add(-2, 'years'),
      end: momentJalaali().add(-1, 'days'),
    },
    {
      disabled: true,
      start: momentJalaali().add(10, 'days'),
      end: momentJalaali().add(5, 'years'),
    },
  ];
  const handleChange = (date) => {
    setDate(date);
  };
  const handleRadioChange = (e) => {
    const { value } = e.target;
    setTime(value);
  };
  const handleOnClose = () => {
    onClose({ date, time });
  };

  return (
    <Dialog open={open}>
      <MuiDialogContent>
        <Calendar
          ranges={range}
          value={date}
          isGregorian={false}
          onChange={handleChange}
        />
        <div style={{ marginTop: '15px' }}>
          <FormLabel component="legend">زمان بارگیری را مشخص کنید:</FormLabel>
          <RadioGroup
            aria-label="loading time"
            name="time"
            value={time}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="morningtillafternoon"
              control={<Radio />}
              label="صبح تا عصر"
            />
            <FormControlLabel
              value="morningtillnoon"
              control={<Radio />}
              label="صبح تا ظهر"
            />
            <FormControlLabel
              value="afternoon"
              control={<Radio />}
              label="بعدازظهر"
            />
            <FormControlLabel
              value="dusktilldown"
              control={<Radio />}
              label="صبح تا شب"
            />
            <FormControlLabel
              value="24h"
              control={<Radio />}
              label="شبانه روز"
            />
            <FormControlLabel
              value="night"
              control={<Radio />}
              label="فقط شب"
            />
          </RadioGroup>
          <FormHelperText>ساعت بارگیری را وارد نمایید</FormHelperText>
        </div>
      </MuiDialogContent>
      <MuiDialogActions>
        <Button variant="contained" color="primary" onClick={handleOnClose}>
          انتخاب
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
}

export default DatePickerDialog;
